<template>
  <h2>Time Events</h2>
</template>

<script>

export default {
  name: 'CategoryDetailsTimeEvents',
  components: {},

  computed: {},

  data () {
    return {};
  },
};
</script>
